import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import * as Events from '../lib/events';
import request from '@vaersaagod/tools/request';
import serialize from 'form-serialize';

export default el => {
    const dom = $(el);
    const form = dom.find('[data-form]');
    const formWrap = dom.find('[data-form-wrap]');
    const input = dom.find('[data-input]');
    const label = dom.find('[data-label]');
    const trigger = $('[data-contact-trigger]');
    const bg = dom.find('[data-bg]');
    const thanks = dom.find('[data-thanks]');
    let isOpen = false;

    const onSubmit = e => {
        e.preventDefault();
        const params = serialize(form.get(0));

        dom.addClass('is-processing');

        request
            .post('/')
            .accept('application/json')
            .send(params)
            .then(res => {
                console.log(res);
                dom.removeClass('is-processing');
                dom.addClass('is-success');
                setTimeout(hideForm, 1000);
            }, error => {
                console.error('Error', error);
                dom.removeClass('is-processing');
                dom.addClass('is-error');
            });
    };

    const hideForm = () => {
        if (isOpen) {
            isOpen = false;
            document.removeEventListener('keyup', keyup);
            TweenMax.to(formWrap.get(0), 0.75, { xPercent: 100, ease: Quint.easeOut, clearProps: 'all', immediateRender: false});
            TweenMax.to(bg.get(0), 0.5, { opacity: 0 });
            TweenMax.set(el, { clearProps: 'all', delay: 0.75, immediateRender: false })
        }
    };

    const keyup = e => {
        const key = e.keyCode || e.which;
        if (key === 27) {
            hideForm();
        }
    };

    const showForm = () => {
        if (!isOpen) {
            isOpen = true;
            document.addEventListener('keyup', keyup);
            TweenMax.set(el, { display: 'block' });
            TweenMax.set(formWrap.get(0), { xPercent: 100 });
            TweenMax.set(bg.get(0), { opacity: 0 });

            TweenMax.to(formWrap.get(0), 0.75, { xPercent: 0, ease: Quint.easeInOut, immediateRender: false });
            TweenMax.to(bg.get(0), 0.4, { opacity: 1, delay: 0.5 });
        }
    };

    const onTriggerClick = e => {
        e.preventDefault();
        showForm();
    };

    const onInputChange = e => {
        const node = e.triggerTarget;
        const sibling = $(node).parent().find('[data-input]');
        console.log(sibling);
        console.log(node.value.length, )
        if (node.value.length > 0 && !sibling.hasClass('has-value')) {
            sibling.addClass('has-value');
        } else if (node.value.length === 0 && sibling.hasClass('has-value')) {
            sibling.removeClass('has-value');
        }
    };

    const init = () => {
        input.on('change', onInputChange);
        form.on('submit', onSubmit);
        trigger.on('click', onTriggerClick);
        $('[data-close-area]').on('click', hideForm);
    };

    const destroy = () => {
        document.removeEventListener('keyup', keyup);
        input.off('change', onInputChange);
        form.off('submit', onSubmit);
        trigger.off('click', onTriggerClick);
        $('[data-close-area]').off('click', hideForm);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Form.js